import type { FaireProductEntity } from "../../entity_types/product";

export const p_663xeznvup: FaireProductEntity = {
  token: "p_663xeznvup",
  type: "product",
  name: "Lemongrass Citrus Donut Bath Bomb",
  brandToken: "b_dw2q739g",
  brandName: "Confident Girls",
  imageUrl:
    "https://cdn.faire.com/fastly/9a87e4d6f46c1e006cbb3a4e11e09fe5d664ee501517838794bde57f7783e366.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description:
    "Donut bath bombs! These amazing bath bombs are packed with plant-based skin loving ingredients and all of the benefits of avocado oil. Their spinning, fizzing and foaming action are not only fun but also contain amazing skin benefits that help to moisturize and hydrate the skin. The avocado oil contains helpful vitamins and nutrients like potassium and lecithin that are absorbed into the skin and assists with new skin cell growth as well as skin cell renewal.\n\n𝗦𝗽𝗲𝗰𝗶𝗳𝗶𝗰𝗮𝘁𝗶𝗼𝗻𝘀\n• Donut Bath Bomb\n• Large, 7 ounces and Small, 3.5 ounces\n• Scented with Lemongrass, bergamot and citrus blend\n\n𝗜𝗻𝗴𝗿𝗲𝗱𝗶𝗲𝗻𝘁𝘀\nSodium Bicarbonate, Citric Acid, Theobroma cacao (cocoa) Seed Butter, Persea Gratissima Avocado Oil, Colloidal Oatmeal, Kaolin Clay, SLSA, Fragrance/Essential Oils",
  tags: [],
  msrpDollars: 5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:18.105Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
